import img1_1 from "./Assets/products/Bata Jeri/1.jpg";
import img1_2 from "./Assets/products/Bata Jeri/2.jpg";
import img1_3 from "./Assets/products/Bata Jeri/3.jpg";

import img2_1 from "./Assets/products/Corset Shine Off White/1.jpg";
import img2_2 from "./Assets/products/Corset Shine Off White/2.jpg";
import img2_3 from "./Assets/products/Corset Shine Off White/3.jpg";
import img2_4 from "./Assets/products/Corset Shine Off White/4.jpg";

import img3_1 from "./Assets/products/Cropped Jeri Azul Bebê/1.jpg";
import img3_2 from "./Assets/products/Cropped Jeri Azul Bebê/2.jpg";
import img3_3 from "./Assets/products/Cropped Jeri Azul Bebê/3.jpg";
import img3_4 from "./Assets/products/Cropped Jeri Azul Bebê/4.jpg";

import img6_1 from "./Assets/products/Top Alika Preto – Linha de Seda/1.jpg";
import img6_2 from "./Assets/products/Top Alika Preto – Linha de Seda/2.jpg";
import img6_3 from "./Assets/products/Top Alika Preto – Linha de Seda/3.jpg";


let all_product = [
  {
    id: 1,
    name: "Crochê - Bata Jeri",
    category: "cropped",
    images: [img1_1, img1_2, img1_3],
    new_price: 54.99,
    old_price: 74.49,
    
  },
  {
    id: 2,
    name: "Crochê - Cropped Jeri Azul Bebê",
    category: "cropped",
    images: [img3_1, img3_2, img3_3, img3_4],
    new_price: 34.49,
    old_price: 64.99,
  },
  {
    id: 3,
    name: "Crochê - Top Alika Preto – Linha de Seda",
    category: "cropped",
    images: [img6_1, img6_2, img6_3],
    new_price: 27.99,
    old_price: 34.49,
  },
  {
    id: 4,
    name: "Crochê - Corset Shine Off White",
    category: "cropped",
    images: [img2_1, img2_2, img2_3, img2_4],
    new_price: 29.99,
    old_price: 44.79,
  }
 
]
 
export default all_product